import { useMutation, useQueryClient } from "@tanstack/react-query";
import React, { createContext, ReactNode, useContext, useState } from "react";
import { apiModulo, apiWhatsApp } from "../services/api";
import { useModal } from "../hooks/ModalContext";

interface FilaTransbordoContextProviderProps {
  children: ReactNode;
}

export interface QueueProps {
  attendanceStartedAt: string
  _id: string;
  name: string;
  chatData: {
    email: string;
    cpfDevedor: string;
    telefones: Array<any>
    endereco: string;
    numeroEndereco: string;
    bairro: string;
    codCredor: string;
    onlySave: boolean;
    foneNumber: string;
  },
  queueId: string;
  createdAt: string;
}

interface FilaTransbordoContextProps {
  devedorFilaSelected: QueueProps;
  fila: QueueProps[];
  getDevedorFilaSelected(devedor: QueueProps): void;
  clearSelectedFila(): void;
  getQueue(data: QueueProps[]): void;
}

const FilaTransbordoContext = createContext<FilaTransbordoContextProps>({} as FilaTransbordoContextProps);

export const FilaProvider = ({ children }: FilaTransbordoContextProviderProps) => {
  const [devedorFilaSelected, setDevedorFilaSelected] = useState<QueueProps>(
    {} as QueueProps
  );
  const [fila, setFila] = useState<QueueProps[]>([]);


  function getQueue(data: QueueProps[]) {
    setFila(data);
  }

  function getDevedorFilaSelected(devedor: QueueProps) {
    setDevedorFilaSelected(devedor);
  }

  function clearSelectedFila() {
    setDevedorFilaSelected({} as QueueProps);
  }



  return (
    <FilaTransbordoContext.Provider
      value={{
        devedorFilaSelected,
        getDevedorFilaSelected,
        clearSelectedFila,
        fila,
        getQueue,
      }}
    >
      {children}
    </FilaTransbordoContext.Provider>
  );
};

export const useFilaTransbordo = () => useContext(FilaTransbordoContext);